import { Component, HostListener } from '@angular/core';
import { ITealiumAnalyticsOptions, TealiumAnalyticsEvent, TealiumAnalyticsService, TealiumConstants } from '@ddt-web/analytics';
import { DialogService } from '@ddt-web/dialog';
import { SimpleDcrContentDialogComponent } from '@ddt-web/elements';
import { IHeaderAngularComp } from 'ag-grid-angular';
import * as result from 'lodash/result';

import { AgSortDirection } from '../../../enums/ag-column-sort-direction.enum';
import { IHeaderCompParams } from '../../../models/ag-header-comp-params.interface';

@Component({
	selector: 'ac-header-cell-renderer',
	templateUrl: './header-cell-renderer.component.html',
	styleUrls: ['./header-cell-renderer.component.scss']
})
export class HeaderCellRendererComponent implements IHeaderAngularComp {
	public headerParams: IHeaderCompParams;
	public sortDirection: string;
	public sortMethod: Function;
	public sortIcon: string;

	constructor(
		private tealiumAnalyticsService: TealiumAnalyticsService,
		private dialogService: DialogService
	) { }

	public agInit(params: IHeaderCompParams): void {
		this.headerParams = params;
		this.sortMethod = params['sortMethod'];
		if (this.sortMethod && params['defaultSort']) {
			this.headerParams.setSort(AgSortDirection.ASC);
		}
		this.sortDirection = this.headerParams.column.getSort();
		this.sortIcon = this.getSortIcon();
		this.headerParams.column.addEventListener('sortChanged', () => {
			this.sortDirection = this.headerParams.column.getSort();
			this.sortIcon = null;
			setTimeout(() => {
				this.sortIcon = this.getSortIcon();
			});
		});
	}

	@HostListener('click', ['$event'])
	public onHeaderClick(): void {
		if (result(this.headerParams, 'column.getColDef.sortable')) {
			if (this.sortMethod) {
				this.progressManualSort();
			} else {
				this.headerParams.progressSort(false);
			}
		}
	}

	public progressManualSort(): void {
		let newSortDirection = AgSortDirection.ASC;
		if (this.sortDirection === AgSortDirection.ASC) {
			newSortDirection = AgSortDirection.DESC;
		} else if (this.sortDirection === AgSortDirection.DESC) {
			newSortDirection = AgSortDirection.ASC;
		}
		this.sortMethod({ sortKey: result(this.headerParams, 'column.getColDef.colId'), direction: newSortDirection });
		this.headerParams.setSort(newSortDirection);
	}

	/**
	 * Sets the text of the iShares Ideas modal and opens it.
	 *
	 * @param {string} trackId id used to track the event
	 * @param {*} infoBubble infoBubble text.
	 */
	public toggleInfoDialog(): void {
		const analyticData: ITealiumAnalyticsOptions = { linkName: 'tooltip_' + this.headerParams.displayName };
		const event = new TealiumAnalyticsEvent(TealiumConstants.TOOLS_EVENT.TOOL_TIP, analyticData);
		this.tealiumAnalyticsService.trackEventTealium(event);

		this.dialogService.open(SimpleDcrContentDialogComponent, {
			showClose: true,
			data: {
				contentDCRKey: this.headerParams.infoBubbleKey
			}
		});
	}

	private getSortIcon(): string {
		if (this.headerParams.column.getColDef().sortable) {
			if (this.sortDirection === AgSortDirection.ASC) {
				return 'sort-asc';
			}
			if (this.sortDirection === AgSortDirection.DESC) {
				return 'sort-desc';
			}
			return 'sort';
		}
	}

	public refresh(): boolean {
		return false;
	}
}
